var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSpeechBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2.68959V10.414C0.5 11.3468 1.23424 12.1036 2.14072 12.1036H9.53235L12.1298 15V12.1033H13.8593C14.7653 12.1033 15.5 11.3465 15.5 10.4137V2.68959C15.4998 1.75652 14.7653 1 13.8593 1H2.14072C1.23424 1 0.5 1.75652 0.5 2.68959ZM10.9483 6.55152C10.9483 5.95185 11.4203 5.46548 12.0031 5.46548C12.5858 5.46548 13.0578 5.95185 13.0578 6.55152C13.0578 7.1517 12.5858 7.63781 12.0031 7.63781C11.4203 7.63781 10.9483 7.15196 10.9483 6.55152ZM6.94514 6.55152C6.94514 5.95185 7.41763 5.46548 7.99988 5.46548C8.58212 5.46548 9.05461 5.95185 9.05461 6.55152C9.05461 7.1517 8.58212 7.63781 7.99988 7.63781C7.41763 7.63781 6.94514 7.15196 6.94514 6.55152ZM2.94221 6.55152C2.94221 5.95185 3.4147 5.46548 3.99694 5.46548C4.57968 5.46548 5.05167 5.95185 5.05167 6.55152C5.05167 7.1517 4.57968 7.63781 3.99694 7.63781C3.41445 7.63807 2.94221 7.15196 2.94221 6.55152Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpeechBubble);
export default __webpack_public_path__ + "static/media/icon-speech-bubble.1a6883b68ce7de595ea85da9cf512e94.svg";
export { ForwardRef as ReactComponent };